<template>
<div  class="top-template">
   <slot name="left-element"></slot>
   <slot name="right-element"></slot>
</div>
  
</template>

<script>
export default {
    name:"TopTemplate"
}
</script>
